<template>
  <transition name="fade">
    <div v-if="!isHidden">
      <v-autocomplete
        ref="autocomplete"
        label="Search my websites & domains"
        dense
        hide-details
        clearable
        outlined
        full-width
        :search-input.sync="search"
        :cache-items="false"
        :loading="isLoading"
        :items="searchItems"
        v-model="selectedService"
        @change="selectSearchItem"
      />
    </div>
  </transition>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { serviceManagable } from '@/helpers/helpers'

const actionsMap = new Map([
  ['manage', (componentInstance, { serviceId, user, domain }) => {
    // Navigate to the manage page
    componentInstance.navigateToSubAccount({ id: serviceId, user, domain })
  }],
  ['domain', (componentInstance, { serviceId }) => {
    // Navigate to the domain manage page
    componentInstance.$router.push({ name: 'domain_info', params: { domainid: serviceId } })
  }],
])

export default {
  name: 'HostingSearch',
  data () {
    return {
      selectedService: '',
      search: '',
    }
  },
  computed: {
    ...mapGetters({
      websitesMerged: 'websitesMerged',
      websitesStatus: 'websitesStatus',
      services: 'services',
      servicesPopulated: 'servicesPopulated',
      domainsPopulated: 'domainsPopulated',
      domains: 'domains',
    }),
    isHidden () {
      return this.$route.path.startsWith('/profile') || this.$route.path.startsWith('/billing')
    },
    isLoading () {
      return this.websitesStatus === 'loading' || !this.domainsPopulated || !this.servicesPopulated
    },
    searchItems () {
      // form the items for the autocomplete
      const websites = this.websitesMerged.map(ws => ({
        text: `${ws.domain} (${ws.hostingPlan})`,
        value: `manage__${ws.serviceId}__${ws.domain}__${ws.user || ''}`,
      }))

      const domains = this.domains.filter(domain => serviceManagable(domain)).map(domain => ({
        text: `${domain.domain} (Domain)`,
        value: `domain__${domain.id}__${domain.domain}__`,
      }))

      return [
        ...websites,
        ...domains
      ]
    }
  },
  methods: {
    serviceManagable,
    ...mapActions(['loadWebsites', 'reportError', 'navigateToSubAccount', 'reportError']),
    selectSearchItem (item) {
      if (!item) return

      // console.log('Selected item:', item)
      const [action, serviceId, domain, user] = item.split('__')

      this.clearAndBlur()

      try {
        if (actionsMap.has(action)) {
          actionsMap.get(action)(this, { serviceId, domain, user: user || undefined })
        }
      } catch (e) {
        this.reportError(e)
      }
    },
    async fetchWebsites () {
      try {
        await this.loadWebsites()
      } catch (e) {
        this.reportError(e)
      }
    },
    clearAndBlur () {
      this.$nextTick(() => {
        this.selectedService = ''
        this.search = ''
        if (this.$refs.autocomplete && this.$refs.autocomplete.blur) {
          this.$refs.autocomplete.blur()
        }
      })
    },
  },
  mounted () {
    this.fetchWebsites()
  },
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: ease-in 0.25s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
